const state = {
  viewport: {},
};

/**
 * Sets new default values for `getDefaultViewport`
 *
 * @param {object} viewport - Object that sets new default values for getDefaultViewport
 * @returns {void}
 */
function setDefaultViewport(viewport) {
  state.viewport = viewport || {};
}

export { state };

export default setDefaultViewport;
